<template>
  <div>
    <h2 class="step-name"> Client Details </h2>

    <div class="step-section">
      <div class="form-group">
        <label for="client_code">Client Code</label>
        <input type="text" v-model="model.client_code" class="form-control" id="client_code" disabled>
      </div>

      <div class="form-group">
        <label for="company">Company</label>
        <input type="text" v-model="model.company" class="form-control" id="company" disabled>
      </div>

      <div class="form-group">
        <label for="full_name">Name</label>
        <input type="text" v-model="model.full_name" class="form-control" id="full_name" disabled>
      </div>

      <div class="form-group">
        <label for="farm_group_name">Farm Group Name</label>
        <input type="text" v-model="model.farm_group_name" class="form-control" id="farm_group_name" disabled>
      </div>

      <div class="form-group">
        <label for="previous_winter_consult_year">Previous Consult Year</label>
        <input type="text" v-model="model.previous_winter_consult_year" class="form-control" id="previous_winter_consult_year" disabled>
      </div>

      <div class="form-group">
        <label for="zone">Zone</label>
        <input type="text" v-model="model.zone" class="form-control" id="zone" disabled>
      </div>

      <div class="form-group">
        <label for="full_address">Address</label>
        <input type="text" v-model="model.full_address" class="form-control" id="full_address" disabled>
      </div>

      <div class="form-group">
        <label for="phone" :class="{ 'text-danger': errors.has('phone') }">Phone</label>
        <input type="text" v-model="model.phone" class="form-control" id="phone" :disabled="isReadOnly">

        <span v-show="errors.has('phone')" class="text-danger">{{ errors.first('phone') }}</span>
      </div>

      <div class="form-group">
        <label for="mobile" :class="{ 'text-danger': errors.has('mobile') }">Mobile</label>
        <input type="text" v-model="model.mobile" class="form-control" id="mobile" :disabled="isReadOnly">

        <span v-show="errors.has('mobile')" class="text-danger">{{ errors.first('mobile') }}</span>
      </div>

      <div class="form-group">
        <label for="email" :class="{ 'text-danger': errors.has('email') }">E-Mail</label>

        <input type="email" class="form-control" id="email" name="email" v-model="model.email" :disabled="isReadOnly">

        <span v-show="errors.has('email')" class="text-danger">{{ errors.first('email') }}</span>
      </div>

      <div class="form-group">
        <label for="pref_contact_method">Pref.Contact Method</label>
        <select class="form-control" id="pref_contact_method" v-model="model.pref_contact_method" :disabled="isReadOnly">
            <option value="Email">E-Mail</option>
            <option value="Mail">Mail</option>
            <option value="Txt">Txt</option>
            <option value="Phone">Phone</option>
        </select>
      </div>

      <div class="form-group">
        <label for="keyvets">Keyvets</label>
        <input type="text" v-model="model.vision_keyvets" class="form-control" disabled>
      </div>

    </div>

  </div>

</template>

<script>
import baseComponent from '@/mixins/base_consult_component'

export default {
  mixins: [ baseComponent ],
  data() {
    return {
      model: {
        client_code: "",
        company: "",
        full_name: "",
        full_address: "",
        phone: "",
        mobile: "",
        email: "",
        pref_contact_method: "",
        notes: "",
        contacts_free_text: "",
        client_markers: "",
        vision_keyvets: "",
        farm_group_name: "",
        // "COMMENTS": {
        //   current: "",
        //   last_year: "",
        // },
      },
    }
  },
};
</script>
